<script setup lang="tsx">
import type { Column } from '@/stores/column'
import { computed, type Ref } from 'vue'
import OrderLabel from '../widgets/OrderLabel.vue'

const props = defineProps<{
	columns: Ref<Column>[]
	table?: string
	disableOrder?: boolean
}>()

const visibleColumns = computed(() => {
	return props.columns.filter((ch) => ch.value.isVisible && (!props.table || ch.value.customField?.table === props.table))
})
</script>

<template>
	<th v-for="(ch, i) in visibleColumns" :key="ch.value.customField?.id">
		<OrderLabel v-if="!props.disableOrder" v-model="props.columns[i].value">{{ ch.value.label }}</OrderLabel>
		<template v-else>{{ ch.value.label }}</template>
	</th>
</template>
